import PropTypes from 'prop-types'

const propTypes = {
  classes: PropTypes.object.isRequired,
  completeHandler: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
}

export default propTypes
